import { MyAreaCategoryFilterProps } from '@msc-b2c/interfaces/types';
import styles from './categoryfilter.module.scss';
import { Checkbox, Text } from '@msc-b2c/shared-components';

export function CategoryFilter({
  categoryFilterTitle,
  isButtonsDisabled,
  categoryFilters,
  handleCheckboxChange,
}: Readonly<MyAreaCategoryFilterProps>) {
  return (
    <div
      className={`${styles['categoryFilterContainer']} ${isButtonsDisabled ? '' : 'dirtFilter'}`}
    >
      <Text
        text={categoryFilterTitle}
        styleOption={'h5 category-filter-title'}
        tagHtml={'span'}
      />
      {/* Category Filter Checkboxes */}
      <div className={styles['categoryFilterCheckBoxesContainer']}>
        {categoryFilters &&
          categoryFilters?.length > 0 &&
          categoryFilters?.map((categoryFilter, index) => (
            <Checkbox
              key={`${categoryFilter.filterType}-${index}`}
              checked={categoryFilter.checked ?? false}
              styleOptions={'no-margin'}
              text={
                <Text
                  text={categoryFilter.filterLabel}
                  styleOption={categoryFilter.checked ? 'bold body-default' : 'body-default'}
                />
              }
              onChange={() => handleCheckboxChange(index)}
            />
          ))}
      </div>
    </div>
  );
}
